import {Component, OnInit, ViewChild, TemplateRef, Input, forwardRef, ChangeDetectorRef, Injector, OnChanges, SimpleChanges} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InputGridFunctionsFiltersModel } from './input-grid-functions-filters.model';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl, Validators } from '@angular/forms';
import { ExpressionBuilderModel } from '../../expression-builder/expression-builder.model';
import { CODE_WORKFLOW_COMPONENT, Model_WorkflowComponent } from 'src/app/app.models';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../workflow-components.service';

@Component({
    selector: 'abw-input-grid-functions-filters',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputGridFunctionsFiltersComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => InputGridFunctionsFiltersComponent),
        multi: true
      }
    ],
    templateUrl: './input-grid-functions-filters.component.html',
    styleUrls: ['./input-grid-functions-filters.component.scss']
})
export class InputGridFunctionsFiltersComponent extends AbstractWorkflowFormComponent<InputGridFunctionsFiltersModel, any> {
    @ViewChild('myTemplate') customTemplate: TemplateRef<any>;
    dialogRef: MatDialogRef<any, any> = null;
    expressionBuilderModel: ExpressionBuilderModel;
    filtersFormControl = new FormControl(null, Validators.required);

    constructor(
        protected _workflowComponentsService: WorkflowComponentsService,
        protected _cdf: ChangeDetectorRef,
		protected _injector: Injector,
        public dialog: MatDialog
    ) {
        super(_workflowComponentsService, _cdf, _injector);
    }

    openDialog(): void {
        this.expressionBuilderModel = ExpressionBuilderModel.initModel({
            ID: 'expression-builder',
            CODE: CODE_WORKFLOW_COMPONENT.EXPRESSION_BUILDER,
            LABEL: 'Expression Builder'
        }, {
            datasource: this.datasourceDatas.map(component => ({ ID: component.ID, TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]` })),
            COMPONENTS: [],
            VARIABLES_ENVIRONNEMENT: [],
            DATASOURCES: []
        });

        this.dialogRef = this.dialog.open(this.customTemplate, {
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });

        this.dialogRef.afterClosed().subscribe((result?: any) => {
            if (result === undefined) { return; }
            this.value = result;
            this.propagateChange(this.value);
            this._cdf.detectChanges();
        });
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}
    
    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: any) {
        this.value = value; 
        this.filtersFormControl.patchValue(value);
    }

    dismiss() {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.filtersFormControl.invalid) { return; }
        this.dialogRef.close(this.filtersFormControl.value);
    }
}